"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaHelper = void 0;
class MediaHelper {
    static getMicrophonePermissionState() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (navigator && navigator.permissions && navigator.permissions.query) {
                    var permissionStatus = yield navigator.permissions.query({ name: 'microphone' });
                    return permissionStatus.state;
                }
            }
            catch (_) { }
            return 'unsupported';
        });
    }
    static classifyMicrophoneError(error, permissionState) {
        var state = permissionState || 'unsupported';
        var errorName = error && typeof error === 'object' && 'name' in error
            ? String(error.name || '')
            : '';
        if (state === 'denied') {
            return { ok: false, reason: 'permission-denied', errorName: errorName };
        }
        if (errorName === 'NotAllowedError' || errorName === 'PermissionDeniedError' || errorName === 'SecurityError') {
            return {
                ok: false,
                reason: state === 'prompt' ? 'permission-prompt' : 'permission-denied',
                errorName: errorName,
            };
        }
        if (errorName === 'NotFoundError' ||
            errorName === 'DevicesNotFoundError' ||
            errorName === 'OverconstrainedError' ||
            errorName === 'ConstraintNotSatisfiedError') {
            return { ok: false, reason: 'device-unavailable', errorName: errorName };
        }
        if (errorName === 'NotReadableError' || errorName === 'TrackStartError' || errorName === 'AbortError') {
            return { ok: false, reason: 'device-in-use', errorName: errorName };
        }
        if (!(navigator && navigator.mediaDevices && navigator.mediaDevices.getUserMedia)) {
            return { ok: false, reason: 'not-supported', errorName: errorName };
        }
        return { ok: false, reason: 'unknown', errorName: errorName };
    }
    static verifyMediaAccess(inputDeviceId, outputDeviceId) {
        return __awaiter(this, void 0, void 0, function* () {
            var micResult = yield MediaHelper.checkMicrophone(inputDeviceId);
            if (!micResult.ok) {
                return {
                    mic: false,
                    micReason: micResult.reason,
                    speaker: false,
                    speakerReason: 'not-tested',
                };
            }
            if (typeof Audio === 'undefined') {
                return {
                    mic: true,
                    micReason: 'ok',
                    speaker: false,
                    speakerReason: 'not-supported',
                };
            }
            var audio = new Audio('img/count-down.mp3');
            var outputAudio = audio;
            var sinkId = outputDeviceId === 'default' ? '' : (outputDeviceId || '');
            audio.muted = true;
            if (sinkId && !outputAudio.setSinkId) {
                return { mic: true, micReason: 'ok', speaker: false, speakerReason: 'not-supported' };
            }
            if (outputAudio.setSinkId) {
                try {
                    yield outputAudio.setSinkId(sinkId);
                }
                catch (_) {
                    return { mic: true, micReason: 'ok', speaker: false, speakerReason: 'device-unavailable' };
                }
            }
            try {
                var playback = audio.play();
                if (playback && playback.then) {
                    yield playback;
                }
                return { mic: true, micReason: 'ok', speaker: true, speakerReason: 'ok' };
            }
            catch (_) {
                return { mic: true, micReason: 'ok', speaker: false, speakerReason: 'playback-blocked' };
            }
            finally {
                try {
                    audio.pause();
                }
                catch (_) { }
            }
        });
    }
    static getSystemDefaultAudioInput() {
        return __awaiter(this, void 0, void 0, function* () {
            var permissionState = 'unsupported';
            try {
                permissionState = yield MediaHelper.getMicrophonePermissionState();
                if (!(navigator && navigator.mediaDevices && navigator.mediaDevices.getUserMedia)) {
                    return { ok: false, deviceId: '', label: '', reason: 'not-supported' };
                }
                var stream = yield navigator.mediaDevices.getUserMedia({ audio: true, video: false });
                var deviceId = '';
                var label = '';
                try {
                    var tracks = stream && stream.getAudioTracks ? stream.getAudioTracks() : [];
                    if (tracks.length > 0) {
                        var settings = tracks[0].getSettings ? tracks[0].getSettings() : {};
                        deviceId = String(settings.deviceId || '');
                        label = tracks[0].label || '';
                    }
                }
                finally {
                    try {
                        if (stream && stream.getTracks) {
                            var allTracks = stream.getTracks();
                            for (var i = 0; i < allTracks.length; i++) {
                                allTracks[i].stop();
                            }
                        }
                    }
                    catch (_) { }
                }
                return { ok: true, deviceId: deviceId, label: label, reason: 'ok' };
            }
            catch (error) {
                var result = MediaHelper.classifyMicrophoneError(error, permissionState);
                return {
                    ok: false,
                    deviceId: '',
                    label: '',
                    reason: result.reason,
                    errorName: result.errorName,
                };
            }
        });
    }
    static checkMicrophone(deviceId) {
        return __awaiter(this, void 0, void 0, function* () {
            var permissionState = 'unsupported';
            try {
                permissionState = yield MediaHelper.getMicrophonePermissionState();
                if (!(navigator && navigator.mediaDevices && navigator.mediaDevices.getUserMedia)) {
                    return { ok: false, reason: 'not-supported' };
                }
                var audioConstraints = true;
                if (deviceId && deviceId !== 'default') {
                    audioConstraints = { deviceId: { exact: deviceId } };
                }
                var stream = yield navigator.mediaDevices.getUserMedia({ audio: audioConstraints, video: false });
                try {
                    if (stream && stream.getTracks) {
                        var tracks = stream.getTracks();
                        for (var i = 0; i < tracks.length; i++) {
                            tracks[i].stop();
                        }
                    }
                }
                catch (_) { }
                return { ok: true, reason: 'ok' };
            }
            catch (error) {
                return MediaHelper.classifyMicrophoneError(error, permissionState);
            }
        });
    }
}
exports.MediaHelper = MediaHelper;
